module.exports = __webpack_public_path__ + "img/canada.9237d94.svg";